import { render, staticRenderFns } from "./customizationTextSection.vue?vue&type=template&id=fc549172"
import script from "./customizationTextSection.vue?vue&type=script&lang=js"
export * from "./customizationTextSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports